<script setup lang="ts">
import ULayoutDefaultHeaderToolbarSignature from './ULayoutDefaultHeaderToolbarSignature.vue'
import ULayoutDefaultHeaderToolbarSearchBar from './ULayoutDefaultHeaderToolbarSearchBar.vue'
import ULayoutDefaultHeaderToolbarButtons from './ULayoutDefaultHeaderToolbarButtons.vue'
import ULayoutDefaultHeaderToolbarButtonAppearance from './ULayoutDefaultHeaderToolbarButtonAppearance.vue'
import ULayoutDefaultHeaderToolbarButtonLanguage from './ULayoutDefaultHeaderToolbarButtonLanguage.vue'
import ULayoutDefaultHeaderToolbarButtonHelp from './ULayoutDefaultHeaderToolbarButtonHelp.vue'
import ULayoutDefaultHeaderToolbarButtonLogin from './ULayoutDefaultHeaderToolbarButtonLogin.vue'
import ULayoutDefaultHeaderToolbarButtonProfile from './ULayoutDefaultHeaderToolbarButtonProfile.vue'
import NotificationMenu from '@/components/menu/notifications/HeaderMenu.vue'

type Props = {
  authenticated?: boolean
}
withDefaults(defineProps<Props>(), {
  authenticated: false,
})
</script>

<template>
  <u-layout-default-header-toolbar-signature />
  <q-space />
  <u-layout-default-header-toolbar-search-bar />
  <u-layout-default-header-toolbar-buttons>
    <u-layout-default-header-toolbar-button-appearance v-if="!authenticated" />
    <u-layout-default-header-toolbar-button-language v-if="!authenticated" />
    <u-layout-default-header-toolbar-button-help />
    <q-btn
      v-if="authenticated"
      :to="{ name: 'dashboardProjects' }"
      color="primary"
      flat
      icon="mdi-monitor-dashboard"
      round
    />
    <NotificationMenu v-if="authenticated" />
    <u-layout-default-header-toolbar-button-profile v-if="authenticated" />
    <u-layout-default-header-toolbar-button-login v-else />
  </u-layout-default-header-toolbar-buttons>
</template>
